import {
  inTestEnvironment,
  inDevEnvironment,
  inStagingEnvironment,
} from 'shared/javascripts/util/environment'
import { postJson } from 'shared/javascripts/util/request'

interface EmbedVideoViewEventData {
  partnerKey?: string
  time?: number
  id?: number
  player?: { el_: HTMLElement & { dataset: DOMStringMap } }
}

function trackEmbedVideoViews(eventName: string, eventData: EmbedVideoViewEventData): void {
  if (eventName !== 'player.videoCurrentTime') {
    return
  }

  const videoCurrentTimeTrigger = inTestEnvironment() ? 1 : 30
  const playerDOMElement = eventData.player?.el_

  if (
    eventData.partnerKey !== undefined &&
    parseInt(String(eventData.time)) === videoCurrentTimeTrigger &&
    playerDOMElement?.dataset.embedTracked === undefined
  ) {
    // The event 'player.videoCurrentTime' is triggered multiple times per second, e.g. 1.13, 1.47 and 1.98
    // We only want to send the event once per second, so we need to remember if the event was already sent
    eventData.player!.el_.dataset.embedTracked = 'true'
    sendStats({ embed_video_view: { video_id: eventData.id, partner_key: eventData.partnerKey } })
  }
}

export function trackStats(eventName: string, eventData: Record<string, unknown>): void {
  trackEmbedVideoViews(eventName, eventData as EmbedVideoViewEventData)
}

export function sendStats(stats: Record<string, unknown>): void {
  if (inDevEnvironment() || inStagingEnvironment()) {
    console.log('[Studyflix Stats] Tracking event', stats)
  }

  if (inTestEnvironment()) {
    window.statsLayer = window.statsLayer || []
    window.statsLayer.push(stats)
  }

  void postJson('/stats', { stats })
}
